<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >Manage consignees</small
        >
      </legend>
      <div></div>
      <div>
        <div class="consigneesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading consignees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemConsignees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                class="btn btn-info btn-sm btn-block"
                @click="viewConsignees(props.row.id)"
              >
                <i class="fa fa-plus"></i> Add trip
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
import { newConsignee } from "../routes/routes";
export default {
  data() {
    return {
      columns: [
        {
          label: "Consignee name",
          field: "consignee_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter consignee name",
          },
        },
        {
          label: "Phone number",
          field: "phone_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone number",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadConsignees();
  },
  computed: {
    ...mapGetters(["systemConsignees", "Consignee"]),
  },
  methods: {
    ...mapActions(["loadConsignees", "viewConsignees"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/trips/trip.vue